import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useSession } from "0.Mine/2.Context/sessionContext";
import { Customer } from "0.Mine/3.Interfaces/customer";
import { CustomerDetails } from "0.Mine/3.Interfaces/customerDetails";
import { DashboardAnalytics } from "0.Mine/3.Interfaces/dashboard";
import axiosInstance from "0.Mine/axiosInstance";

import { QlickupActions, useQlickupAPI } from "../APICall";

export const UseHandleDashboard = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const getDashboardData = async (businessid: number) => {
    const response = await QlickUpAPI(
      businessid.toString(),
      "getDashboardData",
      null,
      "dashboard",
      QlickupActions.GET
    );

    console.log("Dashboard Data", response);
    return response as DashboardAnalytics;
  };

  return { getDashboardData };
};
